import { v4 as uuidv4, validate as uuidValidate, version as uuidVersion } from "uuid";

const emptyGuid = "00000000-0000-0000-0000-000000000000";

/**
 * Type that represents a GUID string.
 */
export type Guid = string & { __brand: "guid" };

/**
 * Utility functions for working with GUIDs.
 */
export const Guid = {
  /**
   * Creates a new UUID (v4).
   */
  new(): Guid {
    return uuidv4() as Guid;
  },

  /**
   * The empty UUID constant.
   */
  empty: emptyGuid as Guid,

  /**
   * Checks whether a string value is an empty UUID.
   */
  isEmpty(value: string | null | undefined): boolean {
    return value === emptyGuid;
  },

  /**
   * Checks whether a string value is a valid UUID.
   */
  isGuid(value: string | null | undefined): value is Guid {
    if (!value) return false;
    return uuidValidate(value);
  },

  /**
   * Checks whether a string value is a valid UUID (v4).
   */
  isGuidV4(value: string | null | undefined): value is Guid {
    if (!value) return false;
    return uuidValidate(value) && uuidVersion(value) === 4;
  }
};
